import 'angular';
/* eslint-disable-next-line max-len */
import '../../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/bar-chart.directive';
import template from './places_chart.template.html?raw';

const moduleDependencies = [
  'directives.visualizations.barChart',
];

const bindings = {
  searchJs: '<',
  chartData: '<',
  emptyResultsText: '<'
};

const placesChartController = function() {
  const that = this;
  that.selectedTab = 'regions_inferred';
  that.activeTabData = undefined;

  /**
   * Check if value is present in an array of objects
   *
   * @param {Array} array - array of objects
   * @param {string} key - object key
   * @param {string} value - key value
   *
   * @returns {boolean}
   */
  that.containsKeyValue = (array, key, value) => {
    if (array.length === 0) {
      return false;
    }
    return array.some(element => element[key] === value);
  };

  /**
   * Adds new filter, if unique to places filter in searchJs
   *
   * @param {string} value - Selected Funder
   *
   * @returns {undefined}
   */
  that.addPlaceFilterHandle = (value) => {
    if (!that.containsKeyValue(that.searchJs.filter.places.value, 'name', value)) {
      that.searchJs.filter.places.addValue({name: value});
      that.searchJs.notifyParamChange();
    }
  };

  /**
   * It updates the data to render for the Bar Chart
   * (`activeTabData`) with the selected one and also updates
   * the current selected tab
   *
   * @param {string} selectedTab - Selected Country Tab (regions_inferred, country, region)
   *
   * @returns {undefined}
   */
  that.placesChartTabHandle = selectedTab => {
    that.selectedTab = selectedTab;
    that.activeTabData = that.chartData[selectedTab];
  };
};

const controller = [placesChartController];

const options = {
  templateUrl: template,
  bindings,
  controllerAs: 'vm',
  controller
};

angular
  .module('fundingSearchApp.components.placesChart', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('placesChart', options);
